import { useEffect, useState } from 'react';
import { apiUrl } from '../../../api/apiUrl';
import http from '../../../api/axios';
import DataTable from '../../../components/table/DataTable';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../components/button/Button';
import { toast } from 'react-toastify';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { CompanyBankAccount } from '../../../types/CompanyBankAccount';
import { paths } from '../../RouterContainer';
import { columns } from '../../../components/columns/Company/CompanyOptionalFieldsColumns';
import { useTranslation } from '../../../context/translationContext';
interface Props {
  companyId: number;
}
/**
 * Page component represents optional fields for current company
 */
export const DocumentOptionalFieldsPage = ({ companyId }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState<CompanyBankAccount[] | null>(null);
  const { company } = useCurrentCompany();
  const isCurrent = window.location.pathname.includes(`current`);

  /**
   * Loads optional fields
   */
  const fetchData = async () => {
    if (!company) return;
    const response = await http.apiGet({
      url: `${apiUrl.OPTIONAL_FIELD_LIST}?parentId=${company.id}`,
    });
    setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, [company]);

  /**
   * Removes optional field
   * @param id
   * @returns
   */
  const onRemoveItem = async (id: string | number) => {
    if (id === null) return;
    const response = await http.apiDelete({
      url: `${apiUrl.OPTIONAL_FIELD_DELETE}?id=${id}`,
    });
    if (response?.status === 204) {
      toast.success('Success!');
      fetchData();
    }
  };

  /**
   * Redirects to optional field edit page
   * @param id of field
   */
  const onEditItem = (id: string | number) => {
    if (id === null) return;
    navigate(
      `/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
        paths.OPTIONAL_FIELDS
      }/edit/${id}`,
    );
  };

  return (
    <>
      <div className="flex justify-end">
        <Link
          to={`/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
            paths.OPTIONAL_FIELDS
          }/create`}
        >
          <Button
            title={t('general.create-new')}
            color="green"
            icon={<PlusIcon className="w-4 h-4 mr-2" />}
          />
        </Link>
      </div>
      <DataTable
        data={data}
        columns={columns()}
        handleRemove={onRemoveItem}
        handleEdit={onEditItem}
      />
    </>
  );
};
